//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** RSVP Response */
export const RSVP = {
    /** No */
    No: 0,

    /** Yes */
    Yes: 1,

    /**
     * Here's my number, call me Maybe.
     * Not used by Group Scheduler.
     */
    Maybe: 2,

    /** RSVP not answered yet (or doesn't apply) */
    Unknown: 3
} as const;

/** RSVP Response */
export const RSVPDescription: Record<number, string> = {
    0: "No",

    1: "Yes",

    2: "Maybe",

    3: "Unknown"
};

/** RSVP Response */
export type RSVP = typeof RSVP[keyof typeof RSVP];
